var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._v("正在打开扫一扫....")])
}
var staticRenderFns = []

export { render, staticRenderFns }